import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "@/utils/ScrollToTop";
import { CookieConsent, CookieConsentEs } from "@/components/CookieConsent";
import { PopupManagerProvider, KickPromoPopup } from "@/components/Shared";
import { useAnalytics } from "@/hooks";

const PageLayout: React.FC = () => {
  const location = useLocation();
  const isSpanish = location.pathname.startsWith("/es");
  const language = isSpanish ? "es" : "en";

  // Initialize GA4 tracking hooks
  useAnalytics({ language });

  return (
    <PopupManagerProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header language={language} />
        <main className="flex-grow">
          <Outlet />
        </main>
        <Footer language={language} />
      </div>
      {/* Cookie Consent Banner */}
      {isSpanish ? <CookieConsentEs /> : <CookieConsent />}
      {/* Timed Kick promotion popup — appears after 3.5 min, auto-hides after 20s */}
      <KickPromoPopup language={language} />
    </PopupManagerProvider>
  );
};

export default PageLayout;
